@if (badgeInfo(); as badgeInfoValue) {
  <div
    [rtTooltip]="badgeInfoValue.tooltip"
    [rtTooltipEnabled]="!!badgeInfoValue.tooltip"
    [rtTooltipPosition]="'right'"
  >
    <rt-badge
      [color]="'counter-light'"
      [text]="badgeInfoValue.label"
      [iconTmpl]="iconTemplate"
      class="transform-none"
    />
  </div>

  <ng-template #iconTemplate>
    <rt-icon
      size="small-xx"
      [name]="badgeInfoValue.icon.name"
      [colorToken]="badgeInfoValue.icon.color"
      margin-right-small-xx
    />
  </ng-template>
}
